import { useLocation } from "react-router-dom";
import PumpDetail from "./PumpDetail";
import ValveDetail from "./ValveDetail";
import SensorDetail from "./SensorDetail";
import InstrumentHistoryTable from "./InstrumentHistoryTable";

const InstrumentDetail = () => {
  const { state } = useLocation();
  const { id, deviceType,deviceName } = state; // passed from InstrumentsSection → button click

  const t = deviceType?.toLowerCase() ?? "";

  if (t.includes("valve"))  return <ValveDetail 
       historyTable = {
                <InstrumentHistoryTable
                  instrumentId={Number(id)}
                  deviceType={deviceType}
                  deviceName={deviceName}
                />
          
       }
  
  id={id} />;
  if (t.includes("pump"))   return <PumpDetail 
  historyTable={
    <InstrumentHistoryTable
      instrumentId={Number(id)}
      deviceType={deviceType}
      deviceName={deviceName}
    />
  }
  id={id} />;
  if (t.includes("sensor")) return <SensorDetail id={id} 
       historyTable = {
            <InstrumentHistoryTable 
               instrumentId={Number(id)}
               deviceType= {deviceType}
                deviceName={deviceName}
             />
         
       }
  />;

  return <p>Unknown device type</p>;
};

export default InstrumentDetail;